import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { DocType } from '../../enums';
import { DocumentService } from '../../services';

@Component({
  selector: 'kt-docs-viewer',
  templateUrl: './docs-viewer.component.html',
  styleUrls: ['./docs-viewer.component.scss'],
})
export class DocsViewerComponent implements OnInit {
  src: string;
  DocType = DocType;
  loading = new BehaviorSubject(true);
  showErr = new BehaviorSubject(false);
  pages = [];
  pageIndex = 0;
  zoomScale = 1;
  @Input() type: DocType;
  @Input() url: string;

  constructor(private documentService: DocumentService) {}

  ngOnInit(): void {
    if (this.type === DocType.PDF || this.type === DocType.INVOICE) {
      this.src = this.url;
    }

    if (this.type === DocType.HTML) {
      this.documentService
        .getHtmlContent(this.url)
        .pipe(take(1))
        .subscribe((res) => (this.src = res));
    }

    if (this.type === DocType.VIDEO_LINK) {
      if (this.url?.includes('youtube')) {
        const url = this.url?.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        this.src = `https://www.youtube.com/embed/${
          url?.length > 2 ? url[2].split(/[^0-9a-z_-]/i)[0] : ''
        }`;
      }

      if (this.url?.includes('vimeo')) {
        const match = this.url?.match(
          /https?:\/\/(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/,
        );
        this.src = `https://player.vimeo.com/video/${match?.length > 3 ? match[3] : ''}`;
      }

      if (this.url?.includes('microsoftstream')) {
        const url = this.url?.split(/(microsoftstream\.com\/video\/)/);
        this.src = `https://web.microsoftstream.com/embed/video/${
          url?.length > 2 ? url[2].split(/[^0-9a-z_-]/i)[0] : ''
        }`;
      }
    }

    if (this.type === DocType.TIF || this.type === DocType.TIFF) {
      const xhr = new XMLHttpRequest();

      this.loading.next(true);

      xhr.responseType = 'arraybuffer';
      xhr.open('GET', this.url);

      xhr.onload = () => {
        const TiffConstructor = (window as any).Tiff;
        const tiff = new TiffConstructor({ buffer: xhr.response });

        for (let i = 0, len = tiff.countDirectory(); i < len; i++) {
          tiff.setDirectory(i);
          const canvas = tiff.toCanvas();
          const url = canvas.toDataURL('image/png');
          this.pages.push(url);
        }
        this.loading.next(false);
      };

      xhr.onerror = () => {
        this.showErr.next(true);
      };

      xhr.send();
    }
  }

  changePage(event: Event, nav: 'FIRST' | 'PREV' | 'NEXT' | 'LAST'): void {
    event.stopPropagation();

    switch (nav) {
      case 'FIRST':
        this.pageIndex = 0;
        break;
      case 'PREV':
        this.pageIndex = this.pageIndex > 0 ? this.pageIndex - 1 : this.pageIndex;
        break;
      case 'NEXT':
        this.pageIndex =
          this.pageIndex < this.pages.length - 1 ? this.pageIndex + 1 : this.pageIndex;
        break;
      case 'LAST':
        this.pageIndex = this.pages.length - 1;
        break;
    }
  }

  zoom(event: Event, type: 'IN' | 'OUT' | 'FIT'): void {
    event.stopPropagation();

    switch (type) {
      case 'IN':
        this.zoomScale = this.zoomScale * 1.1;
        break;
      case 'OUT':
        this.zoomScale = this.zoomScale * 0.9;
        break;
      case 'FIT':
        this.zoomScale = 1;
        break;
    }
  }
}
